import { render, staticRenderFns } from "./Largas.vue?vue&type=template&id=65d8f78e&scoped=true&"
import script from "./Largas.vue?vue&type=script&lang=js&"
export * from "./Largas.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "65d8f78e",
  null
  
)

export default component.exports